import { Service } from '~/post/types.generated';

export const CanvaLiterals = {
  PublishLabel: 'Add to Buffer',
  FileType: 'png',
  CanvaFilename: 'canva.png',
};

export type CanvaDesignConfig = {
  title: string;
  service: Service | 'instagramStory' | 'omni';
  dimensions: {
    width: string;
    height: string;
    units: string;
  };
};

export const StoryCanvaDesignConfig: CanvaDesignConfig = {
  title: 'Instagram Story',
  service: 'instagramStory',
  dimensions: {
    width: '1080',
    height: '1920',
    units: 'px',
  },
};

export const OmniCanvaDesignConfig: CanvaDesignConfig = {
  title: 'New Image',
  service: 'omni',
  dimensions: {
    width: '1200',
    height: '1200',
    units: 'px',
  },
};
export const CanvaDesignConfigValues: CanvaDesignConfig[] = [
  OmniCanvaDesignConfig,
  StoryCanvaDesignConfig,
  {
    title: 'Instagram',
    service: Service.Instagram,
    dimensions: {
      width: '1080',
      height: '1080',
      units: 'px',
    },
  },
  {
    title: 'Facebook',
    service: Service.Facebook,
    dimensions: {
      width: '940',
      height: '788',
      units: 'px',
    },
  },
  {
    title: 'Twitter',
    service: Service.Twitter,
    dimensions: {
      width: '1600',
      height: '900',
      units: 'px',
    },
  },
  {
    title: 'Mastodon',
    service: Service.Mastodon,
    dimensions: {
      width: '1600',
      height: '900',
      units: 'px',
    },
  },
  {
    title: 'LinkedIn',
    service: Service.Linkedin,
    dimensions: {
      width: '1200',
      height: '627',
      units: 'px',
    },
  },
  {
    title: 'Pinterest',
    service: Service.Pinterest,
    dimensions: {
      width: '1000',
      height: '1500',
      units: 'px',
    },
  },
  {
    title: 'TikTok',
    service: Service.Tiktok,
    dimensions: {
      width: '1080',
      height: '1920',
      units: 'px',
    },
  },
  {
    title: 'Google Business Profile',
    service: Service.Googlebusiness,
    dimensions: {
      width: '1200',
      height: '900',
      units: 'px',
    },
  },
  {
    title: 'Start Page Profile',
    service: Service.StartPage,
    dimensions: {
      width: '1080',
      height: '1080',
      units: 'px',
    },
  },
];
